import React from 'react';
import { Spinner, Row } from 'react-bootstrap';
import cx from 'classnames';

export const LoadingSpinner: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ( { style, className } ) => {
  return (
    <Row className={ cx( 'justify-content-center loading-spinner', className ) } style={ style }>
      <Spinner variant="primary" animation="border" className="justify-content-center" />
    </Row>
  );
};

export const useLoadingSpinner = (): React.ReactElement => {
  const spinner = React.useMemo<React.ReactElement>( () => {
    return <LoadingSpinner />;
  }, [] );
  return spinner;
};

export const useLoadingSpinnerOnFullContainer = (): React.ReactElement => {
  const spinner = React.useMemo<React.ReactElement>( () => {
    return (
      <div>
        <div className="modal-full-container show"></div>
        <div className="modal-full-container">
          <LoadingSpinner />
        </div>
      </div> );
  }, [] );
  return spinner;
};
